export default __webpack_public_path__ + "static/media/elseIcon.b5bacda6.svg";